export default __webpack_public_path__ + "static/media/add-photo-icon.11059d62.svg";